import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-grid',
  templateUrl: './image-grid.component.html',
  styleUrls: ['./image-grid.component.scss']
})
export class ImageGridComponent implements OnInit {

  showGalleryOne = true;
  showGalleryTwo = false;
  showGalleryThree = false;
  showGalleryFour = false;
  showGalleryFive = false;
  showGallerySix = false;

  constructor() { }

  ngOnInit() {
  }

  showSectionOne(){
    this.showGalleryOne = true;
    this.showGalleryTwo = false;
    this.showGalleryThree = false;
    this.showGalleryFour = false;
    this.showGalleryFive = false;
    this.showGallerySix = false;
  }

  showSectionTwo(){
    this.showGalleryOne = false;
    this.showGalleryTwo = true;
    this.showGalleryThree = false;
    this.showGalleryFour = false;
    this.showGalleryFive = false;
    this.showGallerySix = false;
  }

  showSectionThree(){
    this.showGalleryOne = false;
    this.showGalleryTwo = false;
    this.showGalleryThree = true;
    this.showGalleryFour = false;
    this.showGalleryFive = false;
    this.showGallerySix = false;
  }

  showSectionFour(){
    this.showGalleryOne = false;
    this.showGalleryTwo = false;
    this.showGalleryThree = false;
    this.showGalleryFour = true;
    this.showGalleryFive = false;
    this.showGallerySix = false;
  }

  showSectionFive(){
    this.showGalleryOne = false;
    this.showGalleryTwo = false;
    this.showGalleryThree = false;
    this.showGalleryFour = false;
    this.showGalleryFive = true;
    this.showGallerySix = false;
  }

  showSectionSix(){
    this.showGalleryOne = false;
    this.showGalleryTwo = false;
    this.showGalleryThree = false;
    this.showGalleryFour = false;
    this.showGalleryFive = false;
    this.showGallerySix = true;
  }
}
